"use strict";

exports.__esModule = true;
exports.default = void 0;

var _navbar = _interopRequireDefault(require("./navbar"));

var _navbarNav = _interopRequireDefault(require("./navbar-nav"));

var _navbarBrand = _interopRequireDefault(require("./navbar-brand"));

var _navbarToggle = _interopRequireDefault(require("./navbar-toggle"));

var _nav = _interopRequireDefault(require("../nav"));

var _collapse = _interopRequireDefault(require("../collapse"));

var _dropdown = _interopRequireDefault(require("../dropdown"));

var _plugins = require("../../utils/plugins");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = {
  BNavbar: _navbar.default,
  BNavbarNav: _navbarNav.default,
  BNavbarBrand: _navbarBrand.default,
  BNavbarToggle: _navbarToggle.default,
  BNavToggle: _navbarToggle.default
};
var plugins = {
  NavPlugin: _nav.default,
  CollapsePlugin: _collapse.default,
  DropdownPlugin: _dropdown.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components,
    plugins: plugins
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/navbar/index.js
// module id = 405
// module chunks = 0